<template>
  <div :class="classes" @click.prevent="doClick" title="Create Follow" aria-label="Create Follow">
		<block-spinner :active="isLoading" size="4" :color="spinnerColor(existing_alert)" :key="`spinner_${existing_alert}`"></block-spinner>
		<svg-heart v-if="!isLoading" class="btn-follow-icon"></svg-heart>
  </div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

	export default {
		name: 'ActionFollowOrg',

		mixins: [AuthMixins],

		props: {
      org_main_id: {
        type: String,
      },
			org_name: {
        type: String,
      }
    },

    data() {
			return {
				isLoading: false,
				job_alert_id: false,
				saved_alerts: false,
			}
    },

    created() {
    	// console.log("Follow button create for org: " + this.org_main_id);
    },

		methods: {
			doClick() {
				this.isLoading = true;

        if (this.me) {
	        if (!this.existing_alert) {
	        	// Alert has not been made yet.
		        let query = encodeURIComponent('org-name=' + this.org_name);
						let payload = {
			  			'org-main-id': this.org_main_id,
							'query': query,
							'title': this.org_name + ' jobs',
							'frequency': 'Weekly'
			  		}

						this.emitter.emit('gaEventTrack', {'category':'org', 'action':'follow', 'label':this.org_main_id});

			  		return this.$api.followOrganisation(payload).then(
			        (response) => {
			        	if (response.data.status == 'success') {
			        		this.updateUser(response.data.enc_user);
                  this.emitter.emit("openModal", { name: 'AlertCreated', 'job_alert_id': response.data['job_alert_id'] });
			        	}
								this.isLoading = false;
			        }
			      ).catch((response) => {
			        console.log("Could not follow this organisation.", response);
			      });
			    } else {
			    	// Alert already created, just open the edit panel.
			    	this.emitter.emit("openModal", { name: 'EditSavedSearchAlert', 'job_alert_id': this.existing_alert.id });
						setTimeout(() => {
							this.isLoading = false;
						}, 1000);
			    }
			  } else {
	    		// alert('You need to be signed in.');
          this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
					this.isLoading = false;
	    	}
	    },
			spinnerColor(state) {
				return state ? 'text-pink' : 'text-pink';
			}
		},

		computed: {
      classes() {
        return {
          'btn-follow': true,
          'active': this.existing_alert,
        }
      },
			existing_alert() {
				if(this.saved_alerts) {
					let found = this.saved_alerts.find((alert) => {
						return alert['org-main-id'] == this.org_main_id;
					});
					return (found);
				}
			}
    },

    watch: {
    	me() {
    		this.saved_alerts = (this.$store.getters.getUser['saved-alerts'] !== undefined) ? this.$store.getters.getUser['saved-alerts'] : false;
    	}
    }
	}
</script>
